// components/footer/EmployerHowItWorks.jsx
import React from "react";
import EmployerHowToPicture1 from "../../assets/EmployerHowToPicture1.png"; // Add Job button screenshot
import EmployerHowToPicture2 from "../../assets/EmployerHowToPicture2.png"; // Create Job Post modal
import EmployerHowToPicture3 from "../../assets/EmployerHowToPicture3.png"; // Occupational Theme Scores & Big Five
import EmployerHowToPicture4 from "../../assets/EmployerHowToPicture4.png"; // Your Referral Link
import EmployerHowToPicture5 from "../../assets/EmployerHowToPicture5.png"; // Email to Applicant

const EmployerHowItWorks = () => {
    return (
        <div className="min-h-screen bg-darkblue text-lightgray px-6 py-16">
            <div className="max-w-3xl mx-auto">
                <h1 className="text-4xl text-orange text-center mb-8">
                    For Employers – How It Works
                </h1>

                <div className="space-y-6 text-lg">
                    {/* 1. Intro Paragraph */}
                    <p>
                        Every manager knows, the best employees are the ones with intrinsic
                        motivation: the ones who enjoy the work for its own sake. They grow the
                        fastest, work the hardest, and are always willing to put in the extra
                        effort, because they like it, it interests them, and they’re a natural fit.
                        They don’t have to force themselves to do the work, and neither do you.
                    </p>

                    {/* 2. CareerMission & Personality Data */}
                    <p>
                        CareerMission.ai helps you find employees with intrinsic motivation for the
                        position you’re hiring for. Using the same career personality data
                        psychologists use to measure person-environment fit, CareerMission sorts
                        your applicant stack by how similar their interests, motivations, and
                        aptitudes are to the best person you’ve ever had in the role. A
                        recommendation from CareerMission isn’t just the best person for the job,
                        they’re the best person for working relationships with this specific
                        manager and team.
                    </p>

                    {/* Occupational Theme Scores Screenshot */}
                    <div className="flex justify-center">
                        <img
                            src={EmployerHowToPicture3}
                            alt="Occupational Theme Scores"
                            className="rounded-lg shadow-lg max-w-full sm:max-w-xxl"
                        />
                    </div>

                    {/* 3. Choose Your Superstar Target */}
                    <p>
                        Using CareerMission is simple. First, choose your superstar target — your
                        favorite person you’ve ever had in the role you’re trying to fill. If you
                        don’t have a superstar working for you now, don’t worry, you can choose one
                        from your past, or get a recommendation from someone you trust.
                    </p>

                    {/* 4. Add Job & Create Job Post */}
                    <p>
                        Next, click the “Add Job” button to add the job to your profile, along with
                        your target’s name and email address, and a link to the job post.
                        CareerMission will automatically send an email to your target with a link
                        to join and take the CareerMission Personality Inventory, our proprietary
                        career assessment. Your Superstar Target’s assessment results are the
                        benchmark against which we’ll measure your applicants, and everyone else in
                        the CareerMission system.
                    </p>

                    {/* Screenshots for Add Job & Create Job Post */}
                    <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
                        {/* Add Job Button */}
                        <img
                            src={EmployerHowToPicture1}
                            alt="Add Job Button"
                            className="rounded-lg shadow-lg max-w-full sm:max-w-xxl"
                        />

                    </div>
                    <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
                        {/* Create Job Post Modal */}
                        <img
                            src={EmployerHowToPicture2}
                            alt="Create Job Post Modal"
                            className="rounded-lg shadow-lg max-w-full sm:max-w-sm"
                        />
                    </div>

                    {/* 5. Distribute Referral Link */}
                    <p>
                        Next, distribute your referral link to all applicants to the job to invite
                        them to take the assessment too, as an optional part of the application
                        process (like a cover letter). We recommend inserting it into your
                        automated application acknowledgment email or the job post itself.
                    </p>

                    {/* Referral Link Screenshot */}
                    <div className="flex justify-center">
                        <img
                            src={EmployerHowToPicture4}
                            alt="Your Referral Link"
                            className="rounded-lg shadow-lg max-w-full sm:max-w-xxl"
                        />
                    </div>

                    {/* 6. Email to Applicant Example */}
                    <div className="flex justify-center">
                        <img
                            src={EmployerHowToPicture5}
                            alt="Email to Applicant"
                            className="rounded-lg shadow-lg max-w-full sm:max-w-xxl mt-4"
                        />
                    </div>

                    {/* 7. Review Applicants & Relax */}
                    <p>
                        Finally, sit back and relax, as the CareerMission algorithm sorts and ranks
                        your applicants by similarity to your superstar target. When it’s time to
                        review resumes, expand the job and review your applicants — and any other
                        open-to-work CareerMission members who match your target — to see their
                        names, similarity scores, LinkedIn profiles, and email addresses:
                        everything you need to start the conversation.
                    </p>
                    <p>
                        There’s only so many resumes you can get through, and you only have so much
                        time! Spend it on the ones who are most likely to love the work, and
                        working for you.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default EmployerHowItWorks;
